import React from 'react';
import { Title } from 'bloomer/lib/elements/Title';
import styled from 'styled-components';
import moment from 'moment';
import { Section } from 'bloomer/lib/layout/Section';
import { Box } from 'bloomer/lib/elements/Box';

interface PropTypes {
  medicalData: MedicalData[];
  aNumber: Ianimal['aNumber'];
}

const FlexBox = styled(Box)`
  &.box {
    display: flex;
    justify-content: space-between;
  }
`;

const DogMedicalData = ({ medicalData, aNumber }: PropTypes) => {
  const name = medicalData[0].animalName;
  return (
    <Section>
      <Title tag="h3">
        {name} A#{aNumber}
      </Title>
      {medicalData
        .sort(
          (a, b) =>
            moment(a.timeReturned).unix() - moment(b.timeReturned).unix()
        )
        .map((entry, i) => (
          <FlexBox
            key={`${entry.aNumber}-${moment(entry.timeReturned).unix()}`}
          >
            <p>{i + 1}. </p>
            <p>Urine Score: {entry.peeScore}</p>
            <p>Fecal Score: {entry.poopScore}</p>
            <p>Time: {moment(entry.timeReturned).format('h:mm A')}</p>
          </FlexBox>
        ))}
    </Section>
  );
};

export default DogMedicalData;
